
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cph-to-malmo",
      function () {
        return require("private-next-pages/cph-to-malmo.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cph-to-malmo"])
      });
    }
  